import type { SVGProps } from 'react';

const SvgWebFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M9 21H15M12 21V18M5 4H19C20.1046 4 21 4.89543 21 6V16C21 17.1046 20.1046 18 19 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
    />
    <path d='M3 16H21C21 17.1046 20.1046 18 19 18H5C3.89543 18 3 17.1046 3 16Z' fill='currentColor' />
  </svg>
);
export default SvgWebFilled;
